//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    headers: Array,
    registros: Array,
  },
  methods: {
    closeDialog() {
      this.$emit('IMPORTACAODIALOGERROS_CLOSE_DIALOG');
    },
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/importacao/ImportacaoDialogErros.vue?vue&type=script&lang=js&